import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";

const vUI_MasterDataSet_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB MDSet Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    MDSET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Master Data Set Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Master Data Set Name',
            columnResourceName: 'colMDSetName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    SOURCE_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Sources',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Center,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },
    KEYSET_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Key Sets',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Center,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },
    COMPANY_COUNT: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Companies',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Center,
            numberFormat: "#,##0"
        },
        domainOptions: {}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }

};

const MasterDataSetSearchProviderBasic: ISearchProvider = {

    keyFields:
        {
            id: 'WB_MDSET_ID',
            id_ui: 'MDSET_ID',
            name: 'MDSET_NAME'
        },

    searchProviderFields: vUI_MasterDataSet_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_MasterDataSet_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                });
        })
    },
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset = {where: {['WB_MDSET_ID']: {inq: _.map(usrContext.WB_MasterDataSets, 'WB_MDSET_ID')}}}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_MasterDataSet_Search',
                this.searchProviderFields,
                [fieldName])


            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const MasterDataSetSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MDSET_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MDSET_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'MDSET_ID', 'MDSET_NAME', 'SOURCE_COUNT', 'COMPANY_COUNT', 'KEYSET_COUNT', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: MasterDataSetSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const MasterDataSetSearch: ISearch = {
    searchName: "Find Master Data Set",
    renderOptions: {},
    searchProfileIdDefault: "default",
    searchProfiles: [MasterDataSetSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("MasterDataSetBO", "MasterDataSet", MasterDataSetSearch, "Master Data Set Search")

export {MasterDataSetSearch}
